import Footer from "../../components/shared/Footer";
import Header from "../../components/shared/Header";
import ContactUs from "./ContactUs";
import Hero from "./Hero";
import OurFeatures from "./OurFeatures";
import Roadmap from "./Roadmap";

import MobileLights from "../../assets/images/decoration/mobile-lights.svg";

import "./Home.scss";

export default function Home() {
	return (
		<>
			<Header />

			<Hero />

			<div className="home-content">
				<img
					className="decoration mobile-lights"
					src={MobileLights}
					alt="decorative-img"
				/>

				<OurFeatures />

				<Roadmap />

				<ContactUs />
			</div>

			<Footer />
		</>
	);
}
